import { render, staticRenderFns } from "./Tip.vue?vue&type=template&id=642b149e"
import script from "./Tip.vue?vue&type=script&lang=js"
export * from "./Tip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('642b149e')) {
      api.createRecord('642b149e', component.options)
    } else {
      api.reload('642b149e', component.options)
    }
    module.hot.accept("./Tip.vue?vue&type=template&id=642b149e", function () {
      api.rerender('642b149e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/Tip.vue"
export default component.exports